export default "__VITE_ASSET__B2LkJXlv__"